var _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoalsCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75745 16.7489L2.98706 16.4921C1.90904 16.1328 1.35587 14.9401 1.77789 13.885V13.885C1.87121 13.6517 1.91915 13.4028 1.91915 13.1515V12.6385C1.91915 11.7227 2.19023 10.8274 2.69824 10.0654L3.64611 8.64357C3.71567 8.53923 3.83277 8.47656 3.95817 8.47656H10.4167C10.5705 8.47656 10.7221 8.51529 10.8571 8.58894C12.3533 9.40504 13.3575 9.95278 14.6968 10.6833C15.3604 11.0453 16.1002 11.2455 16.8557 11.2675L19.9652 11.3581C20.8488 11.3839 21.6466 11.8932 22.0419 12.6838L22.3191 13.2382L22.5421 13.8361C22.5804 13.9388 22.6 14.0476 22.6 14.1572V14.3969C22.6 15.2795 22.1156 16.0908 21.3387 16.5096L20.8 16.8M13.8679 16.8H10.6511",
    stroke: "#282829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75586 12.1528H7.54533M11.7559 12.1528H7.54533M7.54533 10.3145V12.1528",
    stroke: "#282829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89258 13.9912H9.73088",
    stroke: "#282829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.86584,
    cy: 17.5651,
    r: 1.3717,
    stroke: "#0460ff",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.7897,
    cy: 17.5651,
    r: 1.3717,
    stroke: "#0460ff",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28906 2.23337C5.24587 1.43642 6.45173 1 7.69697 1C8.94221 1 10.1481 1.43642 11.1049 2.23337",
    stroke: "#282829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99805 3.95664C6.48948 3.6075 7.07738 3.41992 7.68022 3.41992C8.28305 3.41992 8.87095 3.6075 9.36238 3.95664",
    stroke: "#282829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67773 5.83984H7.68163",
    stroke: "#0460ff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalsCar);
export default __webpack_public_path__ + "static/media/goals_car.6a5b38ae9f7ee8dbe3e28db9fd63ca34.svg";
export { ForwardRef as ReactComponent };